import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CustomContainer from "./customContainer";
import { getAnalyticsData } from "../../redux/reducer/analyticsDataReducer";
import LoadingSpinner from "../animation/LoadingSpinner";

const AdminInfoSection = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { data, loading, error } = useSelector((state) => state.analytics);

  useEffect(() => {
    dispatch(getAnalyticsData());
  }, [dispatch]);

  if (loading) {
    return <LoadingSpinner />;
  }

  // console.log(data)

  return (
    <div className="w-full">
      {loading && <p>{t("Loading...")}</p>}
      {error && <p className="text-red-500">{t("Error fetching data")}</p>}
      {!loading && !error && data && (
        <div className="flex flex-col space-y-5">
          <div className="flex w-full gap-4">
            <CustomContainer
              title={t("RequestsAwaitingPricing")}
              value={data.pendingLength}
            />
            <CustomContainer
              title={t("NumberOfOrdersInProgress")}
              value={data.cartsLength}
            />
          </div>

          <div className="flex w-full gap-4">
            <CustomContainer
              title={t("shipmentsInDelivery")}
              value={data.shippedLength}
            />
            <CustomContainer
              title={t("shipmentsDelivered")}
              value={data.deliveredLength}
            />
            <CustomContainer
              title={t("OrdersPackaging")}
              value={data.packedLength}
            />
            <CustomContainer
              title={t("NumsOrdersToday")}
              value={data.todayCartsCount}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminInfoSection;
